module.exports = __webpack_public_path__ + "static/check_no.49ba3059.svg";